import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import AdapterDateFns from '@date-io/date-fns';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import { startOfDay, endOfDay, parseISO } from 'date-fns';  // Import parseISO
import { textError } from '../../../assets/styles/appStyles';

const AppDatePicker = ({
  keyName,
  value,
  onChange,
  errorMsg,
  label,
  minDate,
  maxDate,
  disabled
}: {
  onChange: (value: any) => void;
  value: any;
  keyName: string;
  errorMsg: string;
  label: string;
  minDate?: any;
  maxDate?: any;
  disabled?: boolean;
}) => {

  const handleChange = (date: any) => {
    if (date) {
      // Ensure the date is parsed as an ISO string (if it's a string) and reset the time part
      const parsedDate = typeof date === 'string' ? parseISO(date) : date;
      const dateWithoutTime = startOfDay(parsedDate);  // Reset time to midnight
      onChange(dateWithoutTime);
    } else {
      onChange(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl fullWidth>
        <DatePicker
          label={label}
          InputProps={{
            name: keyName,
            id: keyName,
          }}
          renderInput={(params: any) => (
            <TextField
              id={keyName}
              name={keyName}
              variant="outlined"
              error={errorMsg ? true : false}
              {...params}
            />
          )}
          onChange={handleChange}
          value={value ? startOfDay(parseISO(value)) : null}
          minDate={minDate ? startOfDay(parseISO(minDate)) : undefined}
          maxDate={maxDate ? endOfDay(parseISO(maxDate)) : undefined}
          disabled={disabled}
        />
        {errorMsg ? (
          <FormHelperText sx={textError}>{errorMsg}</FormHelperText>
        ) : null}
      </FormControl>
    </LocalizationProvider>
  );
};
export default AppDatePicker;
